import { atom, useAtom } from 'jotai';
import { ProjectDetail } from 'common/types';

export const UserProjectsAtom = atom<ProjectDetail[]>([]);
export const CurrentPublishProjectAtom = atom<ProjectDetail>();

export const useUserProjects = () => {
  const [userProjects, setUserProjects] = useAtom(UserProjectsAtom);
  const [currentPublishProject, setCurrentPublishProject] = useAtom(CurrentPublishProjectAtom);

  return {
    userProjects,
    setUserProjects,
    currentPublishProject,
    setCurrentPublishProject,
  };
};
